<template>
    <div id="works" class="works" :class="{ 'show-all': showAll }">
      <transition-group name="fade" mode="in-out">
        <a v-for="(work, index) in this.filteredWorksPagination" :key="'work-'+index" class="work" :href="work.link">
            <img class="work__image" v-if="work._embedded['wp:featuredmedia'] && work._embedded['wp:featuredmedia'][0]" :src="getWorkImage(work)">
            <div class="work-overlay"></div>
            <img v-if="work.award === true" src="https://wisdom-site-wisdom-com-au.s3.ap-southeast-2.amazonaws.com/uploads/2020/09/award-white.svg" alt="award" class="work__award">
            <div class="work-content">
              <h2 class="work__type" v-html="work.title.rendered"></h2>
              <div class="work__client">{{ getClient(work) }}</div>
            </div>
        </a>
      </transition-group>
      <div class="button" @click="loadMoreWork()">load more</div>
    </div>
    <!-- <clients /> -->
</template>

<script>
import axios from 'axios';
// import Clients from './Clients';

export default {
  name: 'Work',
  data() {
    return {
      works: [],
      categories: [],
      // clients: [],
      currentCategory: '',
      workCount: 0,
      showFirstLoad: 5,
      filterAward: false,
      currentClient: '',
      showAll: false
    }
  },
  components: {
    // Clients
  },
  methods: {
    categoryClickHandler(category) {
      this.currentCategory = category
      this.workCount = this.showFirstLoad
      this.filterAward = false
      this.showAll = false
    },
    getClient(work) {
      let client = []
      if(work._embedded['wp:term'] && work._embedded['wp:term'].length > 0) {
        work._embedded['wp:term'].forEach(terms => {
          terms.forEach((term) => {
            if(term.taxonomy === 'clients') {
              client = term.name
            }
          })
        })
      }
      return client
    },
    loadMoreWork() {
        window.dispatchEvent(new CustomEvent('load-more-work', {
          detail: {
            hide: 'true'
          }
        }));
    },
    getWorkImage(work) {
      console.warn(work)
      if(work && work._embedded['wp:featuredmedia'] && work._embedded['wp:featuredmedia'][0] && work._embedded['wp:featuredmedia'][0]['media_details'] && work._embedded['wp:featuredmedia'][0]['media_details']['sizes'] && work._embedded['wp:featuredmedia'][0]['media_details']['sizes']['large']) {
        return work._embedded['wp:featuredmedia'][0]['media_details']['sizes']['large'].source_url
      }
      return work._embedded['wp:featuredmedia'][0]['media_details']['sizes']['full'].source_url
    }
  },
  mounted() {
    const baseUrl = window.location.origin

    axios.get(`${baseUrl}/wp-json/wp/v2/work?_embed&per_page=2000`)
    .then(response => {
      this.works = response.data
    })
    axios.get(`${baseUrl}/wp-json/wp/v2/expertise`)
    .then(response => {
      this.categories = response.data
    })
    axios.get(`${baseUrl}/wp-json/wp/v2/clients?per_page=2000`)
    .then(response => {
      this.clients = response.data
    })
    this.workCount = this.showFirstLoad

    window.addEventListener('wisdom-posts-client-localstorage-changed', (event) => {
      console.log(event.detail.client)
      if(event.detail.client.count === 1) {
          let filteredWork = this.works.filter(work => {
          let match = false
            if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
            work._embedded['wp:term'].forEach(term => {
              term.forEach(t => {
                if(t.id === event.detail.client.id) {
                  match = true
              }
              })
            })
            return match
        })
        window.location.href = filteredWork[0].link
      }
      this.currentClient = event.detail.client;
      let works = document.getElementById("works");
      works.scrollIntoView();
    });

    window.addEventListener('update-expertise', (event) => {
      this.categoryClickHandler(event.detail.category)
    });

    window.addEventListener('update-show-all', () => {
      this.showAll = true
      this.currentCategory = false
      this.filterAward = false
    });
    
    window.addEventListener('filter-award', (event) => {
      this.filterAward = event.detail.award
    });

    window.addEventListener('load-more-work', () => {
        this.workCount += 6;
        if(this.showLoadMore === false) {
          window.dispatchEvent(new CustomEvent('show-load-more-work', {
            detail: {
              hide: 'true'
            }
          }));
        }
    });
    let self = this
    window.addEventListener("hashchange", () => {
      console.log(window.location.hash)
      if (window.location.hash == '#latest') {
        console.log('latest')
        self.currentCategory = ''
        self.filterAward = false
        self.showAll = false
      }
      if (window.location.hash == '#all') {
        self.currentCategory = ''
        self.filterAward = false
        self.showAll = true
      }
    })

    if(window.location.hash) {
      if (location.hash == '#latest') {
        console.log('latest')
        self.currentCategory = ''
        self.filterAward = false
        self.showAll = false
      }
      console.log(location.hash)
      if (location.hash == '#all') {
        console.log('all')
        self.currentCategory = ''
        self.filterAward = false
        self.showAll = true
      }
    }
  },
  computed: {
    showLoadMore() {
      return this.workCount < this.filteredWorks.length && this.filteredWorks.length > 5
    },
    filteredWorks() {
      let self = this
      if(this.filterAward === true) {
        return this.works.filter(work => {
          return work.award === true
        })
      }
      if(this.currentClient != '') {
        return this.works.filter(work => {
          let match = false
          if(self.currentClient != '') {
            if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
            work._embedded['wp:term'].forEach(term => {
              term.forEach(t => {
                if(t.id === this.currentClient.id) {
                  match = true
              }
              })
            })
            return match
          }
          else {
            return true
          }
        })

      }
      return this.works.filter(work => {
        let match = false
        if(self.currentCategory != '') {
          if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
          work._embedded['wp:term'].forEach(term => {
            term.forEach(t => {
              if(t.id === this.currentCategory.id) {
                match = true
            }
            })
          })
          return match
        }
        else {
          return true
        }
      })
    },
    filteredWorksPagination() {
      if(this.showAll === true) return this.filteredWorks

      return this.filteredWorks.slice(0,this.workCount)
    },
    // industries() {
    //   let industriesArray = [];
    //   this.clients.forEach(client => {
    //     if(!industriesArray.includes(client.industry)) {
    //       industriesArray.push(client.industry)
    //     }
    //   })
    //   return industriesArray;

    // }
  }
}
</script>

<style scoped lang="scss">
.works span {
  display: flex;
  flex-wrap: wrap;
}
.work {
  text-align: left;
  flex-basis: 100%;
  position: relative;
  // height: 40vw;
  text-decoration: none;
  font-family: "Circular std book", Sans-serif;

  @media screen and (min-width: 640px) {
    flex-basis: 33.33%;
    height: 25vw;
  }
}
.work:hover .work-overlay,
.work:hover .work-content {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.work-content {
  padding: 2em 2em 4em 2em;

  @media screen and (min-width: 640px) {
    opacity: 0;
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: right;
    padding: 1em;
    color: white;
  }
}
.work__award {
  width: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.work-overlay {
  display: none;

  @media screen and (min-width: 640px) {
    display: block;
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.5);
  }
}
.work .work__image {
  width: 100%;
  height: 50vw;
  object-fit: cover;
  display: block;

  @media screen and (min-width: 640px) {
    height: 100%;
  }
}

.work .work__type {
  font-size: 23px;
  margin-top: 0;
  margin-bottom: 0.25em;
  color: black;
  font-family: "Circular std book", sans-serif;

  @media screen and (min-width: 640px) {
    font-size: 2.125em;
    color: white;
  }
}
.work .work__client {
  font-family: "Circular std book", sans-serif;
  color: #767676;

  @media screen and (min-width: 640px) {
    font-size: 1.125em;
    margin-top: 0;
    margin-bottom: 0;
    color: white;
  }
}
.work:first-of-type {
  flex-basis: 100%;

  @media screen and (min-width: 640px) {
    flex-basis: 66.66%;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.works.show-all span a {
  flex-basis: 100%;
  // font-size: 10px;
  height: 50vw;


  @media screen and (min-width: 400px) {
    flex-basis: 50%;
    height: 30vw;
  }

  @media screen and (min-width: 640px) {
    flex-basis: 33%;
    height: 25vw;
  }

  @media screen and (min-width: 768px) {
    flex-basis: 25%;
    height: 20vw;
  }
}
</style>
